var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconography - Caesarzkn"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M38.5 12H30.5V7.52001C30.5033 5.83245 29.4472 4.32435 27.8602 3.75052C26.2731 3.17669 24.4967 3.66058 23.42 4.96001L17.9 11.6C16.9983 12.6767 16.5029 14.0356 16.5 15.44V44H38.5C41.8137 44 44.5 41.3137 44.5 38V18C44.5 14.6863 41.8137 12 38.5 12Z",
    fill: "#6B7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M4.5 18V42C4.5 43.1046 5.39543 44 6.5 44H12.5V16H6.5C5.39543 16 4.5 16.8954 4.5 18Z",
    fill: "#6B7CFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon1.b01084a3f54b01fd1b1f4f338e3eec6f.svg";
export { ForwardRef as ReactComponent };